import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

// New function that returns a subtle color palette based on the string
function stringToSubtleColor(string) {
  // Create a hash from the string
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = Math.abs(hash);

  // Define a palette of subtle colors that match the design
  const subtleColors = [
    // Cool blues
    '#e6f3ff', // very light blue
    '#d9edff', // light blue
    '#ecf4fb', // pale blue
    '#f0f7ff', // sky blue hint
    // Subtle grays
    '#f5f7fa', // light gray with blue hint
    '#f0f2f5', // light gray
    '#f7f9fc', // very light gray
    '#edf2f7', // pale gray with blue hint
    // Very pale teals
    '#e6f6f5', // super light teal
    '#e1f0ee', // pale teal gray
    // Pale lavenders
    '#f2f1fa', // very light lavender
    '#eff1f9', // pale lavender gray
  ];

  // Get a color from the palette based on the hash
  return subtleColors[hash % subtleColors.length];
}

function stringAvatar(name) {
  const initials = name.split(' ').map(part => part && part[0]).join('').toUpperCase();
  
  return {
    sx: {
      bgcolor: stringToSubtleColor(name),
      color: '#5e7086', // Subtle text color for the initials (bluish-gray)
      fontWeight: 600,
      border: '1px solid',
      borderColor: 'rgba(0, 0, 0, 0.08)',
    },
    children: (
      <span style={{ fontSize: '12px' }}>{initials}</span>
    ),
  };
}

export default function DynamicAvatarList({ names }) {
  // Ensure names is always an array
  const namesArray = Array.isArray(names) ? names : [names];

  return (
    <Stack direction="row" spacing={2}>
      {namesArray.map((name, index) => (
        <Avatar key={index} {...stringAvatar(name)} />
      ))}
    </Stack>
  );
}


